import React, { useState } from "react";

/**
 * ResponsiveServiceImage
 * Renders a service photo as <picture> with AVIF + WebP sources at 480/800/1200/1600,
 * cropped 4:5. First instance preloads eagerly with fetchpriority; others lazy-load.
 * Shows an écru placeholder while the file is in flight, then fades the image in over 300ms.
 */
const WIDTHS = [480, 800, 1200, 1600];
const SIZES = "(max-width: 767px) 92vw, 42vw";
const ECRU = "#F4EFE7";

const buildSet = (slug, ext) =>
  WIDTHS.map((w) => `/services/${slug}-${w}.${ext} ${w}w`).join(", ");

const ResponsiveServiceImage = ({
  slug,
  alt,
  priority = false,
  className = "",
  testId,
}) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div
      data-testid={testId}
      className={`relative overflow-hidden ${className}`}
      style={{
        backgroundColor: ECRU,
        aspectRatio: "4 / 5",
      }}
    >
      <picture>
        <source type="image/avif" srcSet={buildSet(slug, "avif")} sizes={SIZES} />
        <source type="image/webp" srcSet={buildSet(slug, "webp")} sizes={SIZES} />
        <img
          src={`/services/${slug}-1200.webp`}
          alt={alt}
          width="1200"
          height="1500"
          loading={priority ? "eager" : "lazy"}
          decoding="async"
          fetchPriority={priority ? "high" : "auto"}
          onLoad={() => setLoaded(true)}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
            opacity: loaded ? 1 : 0,
            transition: "opacity 300ms ease-out",
          }}
        />
      </picture>
    </div>
  );
};

export default ResponsiveServiceImage;
